import EcoImg from 'eco-design/base/eco-img';
import { AnimatedGrid } from '../AnimatedSection';
import CommonTitle from '../CommonTitle';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const Automotive: React.FC = () => {
    const { t } = useLang('Automotive');

    return (
        <div className={`${styles.Automotive} GtmModuleData-section`} data-section-id="d3c-Automotive" id="LFP">
            <EcoImg
                className="bg"
                isOpenLazy={true}
                pc="https://websiteoss.ecoflow.com/figma-uploads/1758703100729-fcod28-compressed-%E7%94%B5%E8%8A%AF.jpg"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1758703134549-2lqxey-compressed-Frame%202094654423.jpg"
            />
            <div className="d3m-layout ">
                <div className="text-wrapper">
                    <CommonTitle title={t('title')} desc={t('desc')} />
                    <AnimatedGrid variant="rotateIn" options={{ delay: 200, stagger: 0.15, threshold: 0.2 }} className="list-wrapper">
                        <div className="list-item">
                            <div className="list-item-title">{t('list1_title')}</div>
                            <div className="list-item-desc">
                                {t.rich('list1_desc', {
                                    sup: (text: string) => <sup>{text}</sup>,
                                })}
                            </div>
                        </div>
                        <div className="list-item">
                            <div className="list-item-title">{t('list2_title')}</div>
                            <div className="list-item-desc">
                                {t.rich('list2_desc', {
                                    sup: (text: string) => <sup>{text}</sup>,
                                })}
                            </div>
                        </div>
                    </AnimatedGrid>
                </div>
            </div>
        </div>
    );
};

export default Automotive;
